var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from "react";
import { useLandscapeDisplayInfo } from "..";
import { useSafeArea } from "./hooks";
import styles from "./index.css";
export var SafeAreaView = React.forwardRef(function (props, ref) {
    var edges = props.edges, _a = props.mode, mode = _a === void 0 ? "padding" : _a, className = props.className, style = props.style, children = props.children, rest = __rest(props, ["edges", "mode", "className", "style", "children"]);
    var inRotate = useLandscapeDisplayInfo().inRotate;
    var processedEdges = useMemo(function () {
        if (!edges) {
            return ["top", "right", "bottom", "left"];
        }
        if (!inRotate) {
            return edges;
        }
        return edges.map(function (edge) {
            switch (edge) {
                case "top":
                    return "right";
                case "right":
                    return "bottom";
                case "bottom":
                    return "left";
                case "left":
                    return "top";
            }
        });
    }, [edges, inRotate]);
    var classNames = useMemo(function () {
        var e_1, _a;
        var classNames = [];
        if (className) {
            classNames.push(className);
        }
        try {
            for (var processedEdges_1 = __values(processedEdges), processedEdges_1_1 = processedEdges_1.next(); !processedEdges_1_1.done; processedEdges_1_1 = processedEdges_1.next()) {
                var edge = processedEdges_1_1.value;
                classNames.push(styles["".concat(mode, "-").concat(edge)]);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (processedEdges_1_1 && !processedEdges_1_1.done && (_a = processedEdges_1.return)) _a.call(processedEdges_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return classNames.join(" ");
    }, [processedEdges, className, mode]);
    var _b = useSafeArea(), top = _b.top, right = _b.right, bottom = _b.bottom, left = _b.left, override = _b.override;
    var safeAreaStyle = useMemo(function () {
        var _a;
        if (!override) {
            return {};
        }
        var value = "";
        if (edges) {
            value += "".concat(edges.includes("top") ? top : 0, "px ");
            value += "".concat(edges.includes("right") ? right : 0, "px ");
            value += "".concat(edges.includes("bottom") ? bottom : 0, "px ");
            value += "".concat(edges.includes("left") ? left : 0, "px ");
        }
        else {
            value = "".concat(top, "px ").concat(right, "px ").concat(bottom, "px ").concat(left, "px");
        }
        return _a = {},
            _a[mode] = value,
            _a;
    }, [bottom, edges, left, mode, override, right, top]);
    return (_jsx("div", __assign({ ref: ref, className: classNames, style: __assign(__assign({}, safeAreaStyle), style) }, rest, { children: children })));
});
